import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Footer_Corporate/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Header/HeaderCheckout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/PreviewBar/PreviewBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Refactor/ChatbotDeferred.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/ui/AnchorLink/AnchorLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/components/Wrappers/Main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/ModalsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/SearchContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/SelectUnitContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/ShortlistContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/TemplateContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/context/UTMParametersContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src177562705/src/dp-nextjs/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src177562705/src/dp-nextjs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src177562705/src/dp-nextjs/node_modules/next/dist/client/script.js");
